<!--地址管理 -->
<template>
  <div class="address" v-if="addressList.length != 0">
    <h2 class="adressTitle">历史地址</h2>
    <div>
      <van-loading color="#ff6c02" size="44px" vertical v-if="reqLoading"> 加载中... </van-loading>
      <div class="address-body">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" :offset="20"
          @load="onLoad">
          <van-swipe-cell v-for="(item, index) in addressList" :key="index" :stop-propagation="true"
            :before-close="beforeClose">
            <div class="address-body-card" @click="chooseAddress(index, item)">
              <!-- 去除默认标签 -->
              <div :class="[item.type == 1 ? 'hint' : 'hint-div']" style="opacity: 0;">
                <p v-if="(item.type == 1)">默认</p>
              </div>
              <!-- <div
                class="hint-div"
                v-else
              ></div> -->
              <div class="address-body-card-body">
                <div class="add-content">
                  <div class="user">
                    <div class="user-div">
                      <p class="user-name">{{ item.userName }}</p>
                      <p class="user-phone">{{ item.phone }}</p>
                    </div>
                    <div class="local">
                      {{ `${item.province}${item.city}${item.area}${item.address}` }}
                    </div>
                  </div>
                  <!-- 选中历史地址图标 -->
                  <div v-if="!source" style="opacty: 0">
                    <div v-show="index == isActive ? true : false">
                      <img src="@/assets/img/personalCenter/addcheck.png" class="img" />
                    </div>
                  </div>
                  <!-- 新增单选按钮 -->
                  <van-radio-group v-model="index" v-if="(source === 1)">
                    <van-radio :name="index">
                      <template #icon="">
                        <img class="img-icon" :src="(index == currentIndex) ? activeIcon : inactiveIcon"
                          @click="onClickChangeAddress(index == currentIndex ? -1 : index, index, item)" />
                      </template>
                    </van-radio>
                  </van-radio-group>
                </div>
              </div>
            </div>
            <template #right>
              <div class="delete">
                <img src="@/assets/img/personalImg/delete.png" class="img" @click="close(item.id)" />
              </div>
            </template>
          </van-swipe-cell>
        </van-list>
      </div>
    </div>
    <!-- <div class="address-body-footer">
      <div class="button" @click="addNewAdress">添加新地址</div>
    </div> -->
  </div>
</template>

<script>
import { reqAddressList, reqDeleteAddress } from '@/api/personal/addressController';
import { reqIndentAddress, reqChangeIndent } from '@/api/personal/orderController';
import { reqModifyReceivingAddress } from '@/api/personal/logistics/index';

export default {
  props: {
    newAddressFlag: Boolean,
    delCheck: Boolean,
    chooseIndex: Number,
    oldChoose: Number,
    source: Number,
  },
  data() {
    return {
      pageObj: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      loading: false,
      finished: false,
      addressList: [], // 地址列表
      scroll: 0,
      addressId: 0, // 地址id
      reqLoading: true, // 请求加载
      isActive: -1,
      currentIndex: -1, // 当前选中的历史地址
      activeIcon: require('@/assets/img/personalCenter/addcheck.png'),
      inactiveIcon: require('@/assets/img/personalCenter/nocheckact.png'),
    };
  },

  activated() {
    if (!this.$route.meta.isUseCache) {
      this.source = Number(this.$route.query?.sourse) || 0
      this.currentIndex = -1;
      this.clearAddressList();
    } else {
      this.$route.meta.isUseCache = false;
    }
  },
  watch: {
    newAddressFlag(val) {
      if (val) {
        this.clearAddressList();
      }
    },
    delCheck: {
      immediate: true,
      handler(val) {
        if (val) {
          this.isActive = -1;
        }
      },
      deep: true,
    },
    chooseIndex(val) {
      this.isActive = val;

    },
    oldChoose(val) {
      this.isActive = val;
    },
  },
  created() {
  },
  methods: {
    onClickChangeAddress(val, index, address) {
      this.currentIndex = val;
      if (this.currentIndex === -1) return
      this.$emit('chooseAddress', index, address);
    },
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      if (this.addressList.length >= this.total) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.pageObj.pageNum += 1;
        this.getAddressList(this.pageObj);
      }
    },
    // 获取地址列表
    async getAddressList(data) {
      try {
        const res = await reqAddressList(data);
        if (res.code === 0) {
          this.addressList.push(...res.data.data); // push新获取的数据
          this.total = res.data.total;
          this.loading = false;
          this.reqLoading = false; // 请求加载loading取消
        } else {
          this.$toast('请求错误！');
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    // 清除缓存重新请求
    clearAddressList() {
      this.addressList = [];
      this.pageObj.pageNum = 1;
      this.loading = false;
      this.finished = false;
      this.getAddressList(this.pageObj);
    },
    // 新增地址
    // addNewAdress() {
    //   this.$sendToApp('goNewAdress');
    //   this.$router.push('/newAdress');
    //   // 保存地址信息
    //   sessionStorage.setItem('saveAddressInfo', JSON.stringify({}));
    // },
    // 修改地址
    // async amendAdress(data) {
    //   try {
    //     const res = await reqAddressInfo(data);
    //     if (res.code === 0) {
    //       this.$router.push({
    //         name: 'newAdress',
    //         query: {
    //           type: 'amend',
    //         },
    //       });
    //       sessionStorage.setItem('saveAddressInfo', JSON.stringify(res.data));
    //     } else {
    //       this.$toast('请求错误！');
    //     }
    //   } catch (error) {
    //     this.$toast(error.message);
    //   }
    // },
    // 删除弹窗
    beforeClose({ position, instance }) {
      switch (position) {
        case 'left':
        case 'cell':
        case 'outside':
          instance.close();
          break;
        case 'right':
          this.$dialog
            .confirm({
              closeOnClickOverlay: true,
              message: '确定删除吗？',
            })
            .then(() => {
              this.deleteAddress(instance);
            })
            .catch(() => {
              instance.close();
            });
          break;
        default:
      }
    },
    close(Id) {
      this.addressId = Id;
    },
    // 删除地址
    async deleteAddress(instance) {
      try {
        const res = await reqDeleteAddress(this.addressId);
        if (res.code === 0) {
          this.$toast('删除成功！');
          instance.close();
          this.clearAddressList();
        } else {
          this.$toast('请求错误！');
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    // 选择地址  订单详情跳转进来新增或修改地址
    async selectAddress(addressId) {
      const locationQuery = this?.$route?.query || {};
      const bindAddress = this.$route.query.changeAddress;
      if (Number(locationQuery.sourse) === 1) {
        // 讲义修改地址
        this.modifyHandoutAddress(addressId);
        return;
      }
      if (locationQuery.needBack) {
        sessionStorage.setItem('addressId', addressId);
        this.$router.go(-1);
      } else {
        if (JSON.stringify(locationQuery) === '{}') {
          return;
        }
        const data = bindAddress
          ? {
            id: this.$route.query.orderAddressId,
            userAddressId: addressId,
          }
          : {
            addressId,
            orderNo: locationQuery.orderNo,
          };
        // 新增或修改地址
        try {
          const res = bindAddress ? await reqChangeIndent(data) : await reqIndentAddress(data);
          if (res.code === 0) {
            this.$toast(bindAddress ? '修改地址成功！' : '添加地址成功！');
            this.$router.go(-1);
          } else {
            this.$toast(bindAddress ? `修改地址失败！${res.msg}` : `添加地址失败！${res.msg}`);
          }
        } catch (error) {
          this.$toast(error.message);
        }
      }
    },
    async modifyHandoutAddress(userAddressId) {
      const { code } = await reqModifyReceivingAddress(userAddressId);
      if (code === 0) {
        this.$toast('修改地址成功');
        this.$router.go(-1);
      }
    },
    async chooseAddress(index, address) {
      if (this.source === 1) return;
      this.isActive = index;
      this.$emit('chooseAddress', index, address);
    },
  },
  // 离开路由之前执行的函数
  beforeRouteLeave(to, from, next) {
    // 如果在window中出现的滚动条
    this.scroll = document.documentElement.scrollTop;
    next();
  },
  // 进入路由之前执行的函数
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 如果在window中出现的滚动条
      document.documentElement.scrollTop = vm.scroll;
    });
  },
};
</script>
<style lang="scss" scoped>
.address {
  padding-bottom: 76px;

  .adressTitle {
    padding: 28px 0 25px 36px;
    color: #787878;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
  }

  ::v-deep .van-loading {
    top: 150px;
  }

  ::v-deep .van-swipe-cell__right {
    display: flex;
    align-items: center;
  }

  .delete {
    img {
      width: 72px;
      height: 72px;

      margin-left: 2px;
    }
  }

  &-body {
    width: 100%;
    padding: 0 36px 20px;
    background: #f9f9f9ff;

    ::v-deep .van-swipe-cell {
      &:nth-of-type(1) {
        border-radius: 12px 12px 0 0;
      }

      &:last-child {
        background: red;
        border-radius: 14px 14px 0 0;
      }
    }

    &-card {
      width: 100%;
      background-color: $bgWhite;
      border-radius: 12px;

      .hint-div {
        width: 100%;
        height: 36px;
      }

      .hint {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 74px;
        height: 36px;
        color: $theme_color;
        font-size: 22px;
        background: rgba(255, 108, 2, 0.1);
        border-radius: 15px 0 15px 0;
      }

      &-body {
        padding: 0 36px 0 36px;

        .add-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 29px;
          border-bottom: 2px solid #f5f5f5;

          .user {

            // display: flex;
            // align-items: center;
            // justify-content: space-between;
            // margin-bottom: 11px;
            &-div {
              display: flex;
              align-items: center;
              // justify-content: center;
            }

            &-name {
              color: #333;
              font-weight: 500;
              font-size: 25px;
              line-height: 36px;
            }

            &-phone {
              margin-left: 22px;
              color: #787878;
              font-weight: 400;
              font-size: 25px;
              line-height: 30px;
              line-height: 36px;
            }

            .img {
              width: 36px;
              height: 36px;
            }

            .local {
              max-width: 560px;
              margin-top: 11px;
              color: #333;
              font-weight: 400;
              font-size: 25px;
              line-height: 36px;
              @extend .ellipsis-2;
            }
          }

          .img {
            width: 36px;
            height: 36px;
          }
        }

        .add-content:last-child {
          border: none;
        }

        .img-icon {
          width: 36px;
          height: 36px;
        }
      }
    }

    // &-footer {
    //   position: fixed;
    //   bottom: 0;
    //   left: 0;
    //   width: 100%;
    //   padding: 0 22px 20px;
    //   .button {
    //     @include commonBtn(100%, 91px, $theme_color, 45px, 36px, $bgWhite);

    //     font-weight: normal;
    //   }
    // }
  }
}
</style>
